import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import api from "@/lib/api";

export default function NotificationBell({ variant = "desktop" }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({ notifications: [], unread: 0 });
  const ref = useRef(null);

  const load = () => api.get("/notifications").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h); return () => document.removeEventListener("mousedown", h);
  }, []);

  const openIt = async (n) => {
    await api.post("/notifications/read", { id: n.id }).catch(() => {});
    setOpen(false); load();
    if (n.deep_link) navigate(n.deep_link);
  };
  const markAll = async () => { await api.post("/notifications/read", {}).catch(() => {}); load(); };

  return (
    <div className="relative" ref={ref}>
      <button data-testid={`notif-bell-${variant}`} onClick={() => { setOpen(!open); if (!open) load(); }} className="relative p-2 text-tc-sub hover:text-tc-txt">
        <Bell className="w-5 h-5" />
        {data.unread > 0 && <span data-testid="notif-unread" className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full bg-tc-coach text-tc-bg text-[10px] font-mono flex items-center justify-center">{data.unread}</span>}
      </button>
      {open && (
        <div data-testid="notif-center" className="absolute right-0 mt-2 w-80 max-h-96 overflow-auto tc-card p-0 z-50 border border-white/12">
          <div className="flex items-center justify-between px-3 py-2 border-b border-white/8">
            <span className="text-sm font-semibold">Notifications</span>
            <button data-testid="notif-mark-all" onClick={markAll} className="text-[11px] text-tc-coach">Mark all read</button>
          </div>
          {data.notifications.length === 0 ? (
            <div className="p-4 text-tc-muted text-sm">No notifications yet.</div>
          ) : data.notifications.map((n) => (
            <button key={n.id} data-testid={`notif-item-${n.id}`} onClick={() => openIt(n)}
              className={`w-full text-left px-3 py-2.5 border-b border-white/5 hover:bg-white/[0.03] ${!n.read ? "bg-tc-coach/5" : ""}`}>
              <div className="flex items-center gap-2">
                <span className="text-[9px] font-mono px-1.5 py-0.5 rounded bg-white/5 text-tc-sub uppercase">{n.category}</span>
                {!n.read && <span className="w-1.5 h-1.5 rounded-full bg-tc-coach" />}
              </div>
              <div className="text-sm text-tc-txt mt-1">{n.title}</div>
              <div className="text-[12px] text-tc-sub">{n.body}</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
